import { useSelector } from 'react-redux';

import { FeatureFlagState } from '../redux/featureFlags/root';
import { RootState } from '../redux/root';

export const useFeatureFlags = (): FeatureFlagState => {
    return useSelector((state: RootState) => state.featureFlags);
};
